/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCharactersCharacterIdSkillsSkill } from './GetCharactersCharacterIdSkillsSkill';
import {
    GetCharactersCharacterIdSkillsSkillFromJSON,
    GetCharactersCharacterIdSkillsSkillFromJSONTyped,
    GetCharactersCharacterIdSkillsSkillToJSON,
    GetCharactersCharacterIdSkillsSkillToJSONTyped,
} from './GetCharactersCharacterIdSkillsSkill';

/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdSkillsOk
 */
export interface GetCharactersCharacterIdSkillsOk {
    /**
     * skills array
     * @type {Array<GetCharactersCharacterIdSkillsSkill>}
     * @memberof GetCharactersCharacterIdSkillsOk
     */
    skills: Array<GetCharactersCharacterIdSkillsSkill>;
    /**
     * total_sp integer
     * @type {number}
     * @memberof GetCharactersCharacterIdSkillsOk
     */
    totalSp: number;
    /**
     * Skill points available to be assigned
     * @type {number}
     * @memberof GetCharactersCharacterIdSkillsOk
     */
    unallocatedSp?: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdSkillsOk interface.
 */
export function instanceOfGetCharactersCharacterIdSkillsOk(value: object): value is GetCharactersCharacterIdSkillsOk {
    if (!('skills' in value) || value['skills'] === undefined) return false;
    if (!('totalSp' in value) || value['totalSp'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdSkillsOkFromJSON(json: any): GetCharactersCharacterIdSkillsOk {
    return GetCharactersCharacterIdSkillsOkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdSkillsOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdSkillsOk {
    if (json == null) {
        return json;
    }
    return {
        
        'skills': ((json['skills'] as Array<any>).map(GetCharactersCharacterIdSkillsSkillFromJSON)),
        'totalSp': json['total_sp'],
        'unallocatedSp': json['unallocated_sp'] == null ? undefined : json['unallocated_sp'],
    };
}

export function GetCharactersCharacterIdSkillsOkToJSON(json: any): GetCharactersCharacterIdSkillsOk {
    return GetCharactersCharacterIdSkillsOkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdSkillsOkToJSONTyped(value?: GetCharactersCharacterIdSkillsOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skills': ((value['skills'] as Array<any>).map(GetCharactersCharacterIdSkillsSkillToJSON)),
        'total_sp': value['totalSp'],
        'unallocated_sp': value['unallocatedSp'],
    };
}

